import TextViewer from "../../components/TextViever";

const Cooperation = () => {
  return <TextViewer obszar="cooperation" />;
};

export default Cooperation;
